"use strict";

exports.__esModule = true;
exports.ToolbarSeparator = exports.ToolbarFormInner = exports.ToolbarForm = exports.ModalHeader = exports.ModalFooter = exports.ModalBody = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _ModalHeader = _interopRequireDefault(require("../../../modal/ModalHeader"));

var _ModalBody = _interopRequireDefault(require("../../../modal/ModalBody"));

var _ModalFooter = _interopRequireDefault(require("../../../modal/ModalFooter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const ToolbarForm = _styledComponents.default.form`
    position: absolute;
    top: 20px;
    display: flex;
    justify-content: center;
    width: 100%;
    z-index: 10;

    ${({
  toolbarPosition
}) => toolbarPosition === 'bottom' && (0, _styledComponents.css)`
            top: initial;
            bottom: 20px;
        `}

    .__react_component_tooltip {
        padding: ${({
  theme
}) => theme.space[3]};

        &.type-light {
            box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.2);
        }
    }
`;
exports.ToolbarForm = ToolbarForm;
const ToolbarFormInner = _styledComponents.default.div`
    display: flex;
    height: 50px;
    background-color: rgba(50, 53, 55, 0.95);
    border-radius: 4px;
    z-index: 10;
    align-items: flex-start;
    color: #ffffff;

    ${({
  theme
}) => theme.colors.pdfViewer.toolbar.background && (0, _styledComponents.css)`
            background-color: ${theme.colors.pdfViewer.toolbar.background};
        `}

    ${({
  options
}) => options.toolbarBackgroundColor && (0, _styledComponents.css)`
            background-color: ${options.toolbarBackgroundColor};
        `}

    ${({
  theme
}) => theme.colors.pdfViewerToolbarText && (0, _styledComponents.css)`
            color: ${theme.colors.pdfViewerToolbarText};
        `}

    ${({
  options
}) => options.toolbarTextColor && (0, _styledComponents.css)`
            color: ${options.toolbarTextColor};
        `}

    svg {
        color: #cccccc;

        ${({
  theme
}) => theme.colors.pdfViewer.toolbar.icons && (0, _styledComponents.css)`
                color: ${theme.colors.pdfViewer.toolbar.icons};
            `};

        ${({
  options
}) => options.toolbarIconColor && (0, _styledComponents.css)`
                color: ${options.toolbarIconColor};
            `};
    }
`;
exports.ToolbarFormInner = ToolbarFormInner;
const ToolbarSeparator = _styledComponents.default.div`
    display: block;
    width: 1px;
    height: 38px;
    margin: 6px 0;
    background-color: rgba(255, 255, 255, 0.2);

    ${({
  theme
}) => theme && theme.colors.pdfViewer.toolbar.separators && (0, _styledComponents.css)`
            background-color: ${theme.colors.pdfViewer.toolbar.separators};
        `};

    ${({
  options
}) => options && options.toolbarSeparatorColor && (0, _styledComponents.css)`
            background-color: ${options.toolbarSeparatorColor};
        `};
`;
exports.ToolbarSeparator = ToolbarSeparator;
const StyledModalHeader = (0, _styledComponents.default)(_ModalHeader.default)`
    border: none;
    padding-bottom: 0;

    h5 {
        width: 100%;
        margin: 10px 0 0 0;
        text-align: center;
    }
`;
exports.ModalHeader = StyledModalHeader;
const StyledModalBody = (0, _styledComponents.default)(_ModalBody.default)`
    p {
        text-align: center;
        margin: ${({
  theme
}) => theme.space[4]} ${({
  theme
}) => theme.space[5]};
    }
`;
exports.ModalBody = StyledModalBody;
const StyledModalFooter = (0, _styledComponents.default)(_ModalFooter.default)`
    padding-left: ${({
  theme
}) => theme.space[6]};
    padding-right: ${({
  theme
}) => theme.space[6]};

    button {
        margin: 0 ${({
  theme
}) => theme.space[3]};
    }

    ${({
  theme
}) => theme && theme.colors.button.primary.background && (0, _styledComponents.css)`
            button:last-child {
                color: ${({
  theme
}) => theme.colors.button.primary.background};
            }
        `}
`;
exports.ModalFooter = StyledModalFooter;